module.exports = __webpack_public_path__ + "img/play_all2.94490793.png";